/**
 * 房屋排查-接口列表
 */
import request from "@/utils/request";
import store from "@/store";
import {
  getInvestBuildInfo,
  buildInfoEditAndroid,
  getInvestConfigList,
  getInvestigateSchemeInfo,
  engineerInfoDetailAndroid,
  engineerInfoEditAndroid,
  schemeInfoEditAndroid,
  getInvestCracksList,
  cracksEditAndroid,
  getInvestDisplacementList,
  displacementEditAndroid,
  getInvestReportListAndroid,
  investListAndroid,
  upperCracksListAndroid,
  upperDisplacementListAndroid,
  upperDisplacementEditAndroid,
  upperCracksEditAndroid,
  maintCracksListAndroid,
  maintDisplacementListAndroid,
  maintDisplacementEditAndroid,
  maintCracksEditAndroid,
  maintListAndroid,
  maintEditAndroid,
  roomListAndroid,
  otherRoomListAndroid,
  otherRoomEditAndroid,
  newOtherRoomListAndroid,
  newModelRoomListAndroid,
  newModelRoomEditAndroid,
  otherRoomSyncEditAndroid,
  modelingSaveAndroid,
  modelingListAndroid,
  investReportLockAndroid,
  investReportUnlockAndroid,
  newOtherRoomSyncEditAndroid,
} from "@/api/androidApi";

// 获取选项
export function investConfigList(params) {
  if (store.state.app.isAndroid) {
    return getInvestConfigList(params);
  }
  return request({
    url: "/api/v1/invest/configList",
    method: "get",
    params,
  });
}

/**
 * 一.调查
 */
// 建筑信息-详情
export function buildInfoDetail(params) {
  if (store.state.app.isAndroid) {
    return getInvestBuildInfo(params);
  }
  return request({
    url: "/api/v1/invest/buildInfo",
    method: "get",
    params,
  });
}
// 建筑信息-编辑
export function buildInfoEdit(data) {
  if (store.state.app.isAndroid) {
    return buildInfoEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/buildEdit",
    method: "post",
    data,
  });
}

// 工程信息-详情
export function engineerInfoDetail(params) {
  if (store.state.app.isAndroid) {
    return engineerInfoDetailAndroid(params);
  }
  return request({
    url: "/api/v1/invest/engineerInfo",
    method: "get",
    params,
  });
}

// 工程信息-编辑
export function engineerInfoEdit(data) {
  if (store.state.app.isAndroid) {
    return engineerInfoEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/engineerEdit",
    method: "post",
    data,
  });
}
/**
 * 二.方案
 */
// 方案-详情
export function schemeInfoDetail(params) {
  if (store.state.app.isAndroid) {
    return getInvestigateSchemeInfo(params);
  }
  return request({
    url: "/api/v1/invest/schemeInfo",
    method: "get",
    params,
  });
}
// 方案-编辑
export function schemeInfoEdit(data) {
  if (store.state.app.isAndroid) {
    return schemeInfoEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/schemeEdit",
    method: "post",
    data,
  });
}
/**
 * 三. 建模
 */

// 裂损录入-列表
export function cracksList(params) {
  if (store.state.app.isAndroid) {
    return getInvestCracksList(params);
  }
  return request({
    url: "/api/v1/invest/cracksList",
    method: "get",
    params,
  });
}

// 裂损录入-编辑
export function cracksEdit(data) {
  if (store.state.app.isAndroid) {
    return cracksEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/cracksEdit",
    method: "post",
    data,
  });
}

// 变移录入-列表
export function displacementList(params) {
  if (store.state.app.isAndroid) {
    return getInvestDisplacementList(params);
  }
  return request({
    url: "/api/v1/invest/displacementList",
    method: "get",
    params,
  });
}

// 变移录入-编辑
export function displacementEdit(data) {
  if (store.state.app.isAndroid) {
    return displacementEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/displacementEdit",
    method: "post",
    data,
  });
}
/**
 * 四. 排查
 */

// 排查-选择楼层配置项-构件变移楼层-列表/api/v1/invest/investList
export function investList(params) {
  if (store.state.app.isAndroid) {
    return investListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/investList",
    method: "get",
    params,
  });
}
// 新的获取变移和裂损楼层列表
export function newInvestList(params) {
  if (store.state.app.isAndroid) {
    return investListAndroid(params);
  }
  return request({
    url: "/api/v1/new/investList",
    method: "get",
    params,
  });
}
/**
 * 1. 上部承重结构排查
 */
// 上部承重结构排查-构件裂损-列表
export function upperCracksList(params) {
  if (store.state.app.isAndroid) {
    return upperCracksListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/upperCracksList",
    method: "get",
    params,
  });
}
// 上部承重结构排查
export function newUpperCracksList(params) {
  if (store.state.app.isAndroid) {
    return upperCracksListAndroid(params);
  }
  return request({
    url: "/api/v1/new/modeling/structuralList",
    method: "get",
    params,
  });
}

// 上部承重结构排查-构件裂损-编辑
export function upperCracksEdit(data) {
  if (store.state.app.isAndroid) {
    return upperCracksEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/upperCracksEdit",
    method: "post",
    data,
  });
}

// 上部承重结构排查-构件变移-列表
export function upperDisplacementList(params) {
  if (store.state.app.isAndroid) {
    return upperDisplacementListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/upperDisplacementList",
    method: "get",
    params,
  });
}

// 上部承重结构排查-构件变移-编辑
export function upperDisplacementEdit(data) {
  if (store.state.app.isAndroid) {
    return upperDisplacementEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/upperDisplacementEdit",
    method: "post",
    data,
  });
}

/**
 * 2. 围护结构排查
 */
// 围护结构排查-构件裂损-列表
export function maintCracksList(params) {
  if (store.state.app.isAndroid) {
    return maintCracksListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/maintCracksList",
    method: "get",
    params,
  });
}

// 围护结构排查-构件裂损-编辑
export function maintCracksEdit(data) {
  if (store.state.app.isAndroid) {
    return maintCracksEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/maintCracksEdit",
    method: "post",
    data,
  });
}

// 围护结构排查-构件变移-列表
export function maintDisplacementList(params) {
  if (store.state.app.isAndroid) {
    return maintDisplacementListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/maintDisplacementList",
    method: "get",
    params,
  });
}

// 围护结构排查-构件变移-编辑
export function maintDisplacementEdit(data) {
  if (store.state.app.isAndroid) {
    return maintDisplacementEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/maintDisplacementEdit",
    method: "post",
    data,
  });
}

// 围护结构排查-外围护结构-列表
export function maintList(params) {
  if (store.state.app.isAndroid) {
    return maintListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/maintList",
    method: "get",
    params,
  });
}

// 围护结构排查-外围护结构-编辑
export function maintEdit(data) {
  if (store.state.app.isAndroid) {
    return maintEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/maintEdit",
    method: "post",
    data,
  });
}

// 围护结构排查-查询房间列表
export function roomList(params) {
  if (store.state.app.isAndroid) {
    return roomListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/floor/roomList",
    method: "get",
    params,
  });
}

// 外围护结构-列表
export function otherRoomList(params) {
  if (store.state.app.isAndroid) {
    return otherRoomListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/otherRoomList",
    method: "get",
    params,
  });
}

// 外围护结构-列表
export function newOtherRoomList(params) {
  if (store.state.app.isAndroid) {
    return newOtherRoomListAndroid(params);
  }
  return request({
    url: "/api/v1/new/otherRoomList",
    method: "get",
    params,
  });
}

// 外围护结构-编辑
export function otherRoomEdit(data) {
  if (store.state.app.isAndroid) {
    return otherRoomEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/otherRoomEdit",
    method: "post",
    data,
  });
}

/**
 * 五. 排查汇总
 */

// 排查汇总-列表
export function investReportList(params) {
  if (store.state.app.isAndroid) {
    return getInvestReportListAndroid(params);
  }
  return request({
    url: "/api/v1/invest/reportList",
    method: "get",
    params,
  });
}

// 排查汇总-解锁
export function investReportUnlock(data) {
  if (store.state.app.isAndroid) {
    return investReportUnlockAndroid(data);
  }
  return request({
    url: "/api/v1/invest/reportModelUnlock",
    method: "post",
    data,
  });
}
// 排查汇总-锁定
export function investReportLock(data) {
  if (store.state.app.isAndroid) {
    return investReportLockAndroid(data);
  }
  return request({
    url: "/api/v1/invest/reportModel",
    method: "post",
    data,
  });
}

// 数据录入列表
export function modelingList(params) {
  if (store.state.app.isAndroid) {
    return modelingListAndroid(params);
  }
  return request({
    url: "/api/v1/new/modeling/list",
    method: "get",
    params,
  });
}

// 数据录入-保存
export function modelingSave(data) {
  if (store.state.app.isAndroid) {
    return modelingSaveAndroid(data);
  }
  return request({
    url: "/api/v1/new/modeling/entry",
    method: "post",
    data,
  });
}

// 外围护结构-同步编辑
export function otherRoomSyncEdit(data) {
  if (store.state.app.isAndroid) {
    return otherRoomSyncEditAndroid(data);
  }
  return request({
    url: "/api/v1/invest/otherRoomSyncEdit",
    method: "post",
    data,
  });
}

// 外围护结构-同步编辑
export function newOtherRoomSyncEdit(data) {
  if (store.state.app.isAndroid) {
    return newOtherRoomSyncEditAndroid(data);
  }
  return request({
    url: "/api/v1/new/otherRoom/syncEdit",
    method: "post",
    data,
  });
}

// 获取未创建的房间
export function modelRoomList(params) {
  if (store.state.app.isAndroid) {
    return newModelRoomListAndroid(params);
  }
  return request({
    url: "/api/v1/new/modelRoom/list",
    method: "get",
    params,
  });
}

export function modelRoomEdit(data) {
  if (store.state.app.isAndroid) {
    return newModelRoomEditAndroid(data);
  }
  return request({
    url: "api/v1/new/modelRoom/edit",
    method: "post",
    data,
  });
}

// 数据录入-保存
export function modelingSaveMore(data) {
  // if (store.state.app.isAndroid) {
  //   return modelingSaveAndroid(data);
  // }
  return request({
    url: "/api/v1/new/modeling/entryMore",
    method: "post",
    data,
  });
}

export function addSingle(data) {
  return request({
    url: "/api/v1/new/modeling/addSingle",
    method: "post",
    data,
  });
}
